/**
 * @fileOverView
 * @description Org Members list — mirrors VybPeepsView.
 * @copyright 2015-present Flatirontek LLC
 **/

var AmpersandView = require('ampersand-view');
var OrgMembersTemplate = require('../../templates/widgets/orgmemberstemplate.html');
var OrgMemberView = require('./orgmemberview');
var app = require('ampersand-app');

var OrgMembersView = AmpersandView.extend({

    template: OrgMembersTemplate,

    initialize: function (options) {
        if(app.orgMembers==undefined) app.orgMembers = new app.OrgMembers();
        this.collection = app.orgMembers;
        this.collection.fetch();
    },

    render: function(){
        this.renderWithTemplate(this);
        this.renderCollection(this.collection, OrgMemberView, '#peepstable');
    }

});

module.exports = OrgMembersView;
